export default __webpack_public_path__ + "static/media/basket.75380320.svg";